module.exports = __webpack_public_path__ + "media/images/site/fundamental2_mesas-d9a6b01ce6fc5d55ae4e516fb153fd68.jpg";